import { PreviewInformation } from './../Schema/FilePreviewInformation';
import { createStore } from 'satcheljs';

// the file preview information which is prefetched for recent files
export interface FilesPreviewInformationStore {
    fileInformation: { [index: string]: { previewInformation: PreviewInformation; error: Error } };
}

export const getFilesPreviewInformationStore = createStore<FilesPreviewInformationStore>(
    'filesPreviewInformationStore',
    {
        fileInformation: {},
    }
);
